import { render, staticRenderFns } from "./UploadCertificado.vue?vue&type=template&id=050c259d&"
import script from "./UploadCertificado.vue?vue&type=script&lang=js&"
export * from "./UploadCertificado.vue?vue&type=script&lang=js&"
import style0 from "./UploadCertificado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports